import React, { useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import Box from '../../../../../Global/Box'
import LayoutTable from '../../../../../Global/LayoutTable'
import ModalContentAux from '../../../../../Global/ModalContentAux'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import StatusTransitionsAdd from './StatusTransitionsAdd'
import {
  DELETE_STATUS_TRANSITION,
  GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS,
} from '../../../../../../graphql/Catalog/Status/StatusTransitions'

const configCustomCols = {
  nombre: { grow: 3 },
  progreso: { grow: 1 },
  color: { grow: 1 },
  orden: { grow: 1 },
  eliminar: { grow: 0 },
}

const growCustom = {
  nombre: 1,
  progreso: 0,
  color: 0,
  orden: 0,
  eliminar: 0,
}

const configModalDelete = {
  showCloseButton: true,
  icon: 'warning',
  title: '¿Estas seguro de eliminar el registro?',
  html: <div className="message-container">Esta accion es permanente</div>,
  allowOutsideClick: false,
  buttonsStyling: false,
  showDenyButton: true,
  confirmButtonText: 'Aceptar',
  denyButtonText: 'Cancelar',
  reverseButtons: true,
  customClass: {
    title: 'StandarModalTitle',
    htmlContainer: 'StandarModalHtmlContainer',
    confirmButton: 'btn btn-migrates',
    denyButton: 'btn btn-migrates-white',
    footer: 'btn StandarModalFooterLogOut',
  },
}

const initModal = {
  modalId: null,
  size: 'large',
  title: null,
  content: null,
}

const StatusTransitions = ({ current_status_id, dataCurrentStatus }) => {
  const { showLoading, hideLoading } = useLoading()
  const MySwal = withReactContent(Swal)

  const refModalStatus = useRef(null)

  //STATES
  const [dataTable, setDataTable] = useState([])
  const [closeModal, setCloseModal] = useState(false)
  const [modal, setModal] = useState(initModal)

  //MUTATIONS
  const [deleteTransition] = useMutation(DELETE_STATUS_TRANSITION)

  //QUERIES
  const { loading, error, data, refetch } = useQuery(
    GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS,
    { variables: { current_status_id } }
  )

  //FUNCTIONS
  const handleBtnAccions = async ({ type, item = null }) => {
    if (type === 'delete') {
      return handleDelete(parseInt(item.id))
    }
  }

  const handleDelete = async (id) => {
    MySwal.fire(configModalDelete).then(async (result) => {
      if (result.isConfirmed) {
        showLoading()
        try {
          await deleteTransition({ variables: { id } })
          await refetch()
          return toastSweetAlert({
            mode: 'ok',
            message: 'Registro ha sido eliminado',
          })
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        } finally {
          hideLoading()
        }
      }
    })
  }

  const handleOpenModal = () => {
    setModal({
      id: data.id,
      modalId: `modal${dataCurrentStatus.id}`,
      size: 'large',
      title: `Estatus: ${dataCurrentStatus.name} (${dataCurrentStatus.type})`,
      content: (
        <StatusTransitionsAdd
          current_status_id={current_status_id}
          refetchMain={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  //EFFECTS
  useEffect(() => {
    if (!loading) {
      if (error)
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllStatusTransitionsByCurrentStatusId.map((item) => {
        const nextData = item.NextStatusData

        const respData = {
          nombre: nextData?.name,
          progreso: nextData?.progress ? nextData?.progress + '%' : '',
          color: nextData?.color ? (
            <div
              className="rounded px-1 py-1"
              style={{ backgroundColor: `${nextData?.color}` }}
            >
              {nextData?.color}
            </div>
          ) : (
            ''
          ),
          orden: nextData?.order ? nextData?.order : '',
          eliminar: (
            <div className="">
              <button
                type="button"
                className="btn btn-danger btn-xs"
                onClick={() => handleBtnAccions({ type: 'delete', item })}
                title={`Eliminar ${nextData?.name}`}
              >
                <i className="fas fa-trash" />
              </button>
            </div>
          ),
        }
        return list.push(respData)
      })
      setDataTable(list)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current_status_id, loading, error, data])

  useEffect(() => {
    if (modal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setCloseModal(false)
      setModal(initModal)
    }
  }, [closeModal])

  return (
    <>
      <Box
        classNameHeader="card-header py-1"
        contentHeader={
          <>
            <h3 className="card-title pl-3 mt-0">
              <div>Estatus a transicionar</div>
            </h3>
            <div className={`card-tools mr-2`}>
              <button
                type="button"
                className="btn btn-migrates btn-xs"
                title="Agregar nuevo"
                onClick={() => handleOpenModal()}
              >
                <i className="fas fa-plus" /> Agregar
              </button>
            </div>
          </>
        }
        classCardBody=" "
        content={
          <>
            <LayoutTable
              hideActions
              hideAddNew
              data={dataTable}
              configCustomCols={configCustomCols}
              growCustom={growCustom}
              flagGrowCustom={true}
              wrapFlag={true}
              requery={GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS}
              exportImportButton={false}
              totalCount={dataTable.length}
              loadingData={loading}
              FilterBarPlaceholder="Buscar"
              paginationServer={false}
              withCard={''}
              classCardBody={'pt-2'}
              hideFilterBar={true}
              dense={true}
              noDataComponent={
                <div className="alert alert-default-info p-1">
                  No hay resultados
                </div>
              }
            />
          </>
        }
      />

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalStatus}
      />

      <ModalContentAux
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => setModal(initModal)}
        content={modal.content}
        showFooter={false}
      />
    </>
  )
}

export default StatusTransitions
